// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Rb3Ff","contentWrapper":"styles_contentWrapper__fSM0q","text":"styles_text__yzMyA","link":"styles_link__LEUgw","heading":"styles_heading__dG640"};